import CryptoJS from "crypto-js";

export const PassEncrypted = (data:object) => {
	const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data),'a8sd98f7a9s8df7as9df').toString()
	return encrypt;
}